module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/40_a30f3099eb1000ef12f82507670929b1.jpg";